export default context => {
    $('[data-color-adjust]', context).each(function () {
        const property = $(this).data('color-adjust')
        const winStyle = window.getComputedStyle(document.body)
        const thisStyle = window.getComputedStyle(this)
        const newValue = thisStyle.getPropertyValue(property)
            .replaceAll(/--coing-color-[a-z]+/g, (m) => {
                return winStyle.getPropertyValue(m).replace('#', '%23')
            })
        this.style.setProperty(property, newValue)

    })
}
